import { render, staticRenderFns } from "./healingManage.vue?vue&type=template&id=8ff0b4ce&scoped=true"
import script from "./healingManage.vue?vue&type=script&lang=js"
export * from "./healingManage.vue?vue&type=script&lang=js"
import style0 from "./healingManage.vue?vue&type=style&index=0&id=8ff0b4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff0b4ce",
  null
  
)

export default component.exports